export { ImgSrcsetModule } from './img-srcset.module';
